// Client-side fallback for the `the_content` filter that appends an
// "(opens in new window)" announcement to every target="_blank" link.
//
// The PHP filter handles all server-rendered content. This module exists
// to catch the same pattern in:
//   - 3rd-party widgets that inject their own links at runtime (e.g. the
//     Curator.io social-feed widget, which adds a `crt-logo` branding link
//     to its container after page load)
//   - Any future block JavaScript that builds anchor markup dynamically
//   - AJAX-loaded content (e.g. the directory archive filter results)
//
// The module is idempotent — it skips links that already have the
// announcement (either via inner text mentioning "opens in", "new window"
// or "new tab", or via an aria-label/title attribute that already does).

(function () {
	'use strict';

	var ANNOUNCEMENT_TEXT = ' (opens in new window)';
	var ANNOUNCEMENT_CLASS = 'screen-reader-text';

	function alreadyAnnounced(link) {
		var lowerText = (link.textContent || '').toLowerCase();
		if (lowerText.indexOf('opens in') !== -1
			|| lowerText.indexOf('new window') !== -1
			|| lowerText.indexOf('new tab') !== -1) {
			return true;
		}
		var ariaLabel = (link.getAttribute('aria-label') || '').toLowerCase();
		if (ariaLabel.indexOf('opens in') !== -1
			|| ariaLabel.indexOf('new window') !== -1
			|| ariaLabel.indexOf('new tab') !== -1) {
			return true;
		}
		var title = (link.getAttribute('title') || '').toLowerCase();
		if (title.indexOf('opens in') !== -1
			|| title.indexOf('new window') !== -1
			|| title.indexOf('new tab') !== -1) {
			return true;
		}
		return false;
	}

	function annotate(link) {
		if (!link || link.dataset.targetBlankAnnounced === 'true') {
			return;
		}
		// Use a flag on the element so we don't re-process it. This also
		// prevents the MutationObserver from re-firing on the same node when
		// we append our own span (which itself is a child mutation).
		link.dataset.targetBlankAnnounced = 'true';
		if (alreadyAnnounced(link)) {
			return;
		}
		var span = document.createElement('span');
		span.className = ANNOUNCEMENT_CLASS;
		span.textContent = ANNOUNCEMENT_TEXT;
		link.appendChild(span);
	}

	function processAll(root) {
		var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
		var links = scope.querySelectorAll('a[target="_blank"]');
		for (var i = 0; i < links.length; i++) {
			annotate(links[i]);
		}
	}

	function init() {
		processAll(document);

		// Observe future DOM additions so we catch 3rd-party widgets like
		// Curator.io that inject their branding links well after the initial
		// DOMContentLoaded event. We only walk added subtrees, not the whole
		// document on every mutation, to keep this cheap.
		if (typeof MutationObserver === 'function') {
			var observer = new MutationObserver(function (mutations) {
				for (var i = 0; i < mutations.length; i++) {
					var added = mutations[i].addedNodes;
					for (var j = 0; j < added.length; j++) {
						var node = added[j];
						if (node && node.nodeType === 1) {
							if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
								annotate(node);
							} else if (typeof node.querySelectorAll === 'function') {
								processAll(node);
							}
						}
					}
				}
			});
			observer.observe(document.body, { childList: true, subtree: true });
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
